import { ICellRendererParams } from '@ag-grid-community/core'
import { DataTable, DataTablePagination } from 'components/common'
import { usePageAccess, useQuery } from 'hooks'
import useModal from 'hooks/useModal'
import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchPendingErpSyncOrders } from 'utils/api/pendingErpSyncApi'
import { getPendingErpSyncOrderColumns } from './utils'
import ConfirmResyncOrderModal from './confirmResyncOrderModal'

const PendingErpSyncOrdersTable = () => {
  const [ordersData, setOrdersData] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)

  const [gridParams, setGridParams] = useState<ICellRendererParams>()

  const { search } = useLocation()
  const { getAllQueries } = useQuery()
  const { closeModal, isOpen, openModal } = useModal()
  const { isEditor } = usePageAccess()

  const getOrders = async () => {
    setLoading(true)
    const { limit, search: searchTerm, page } = getAllQueries()
    try {
      const { data } = await fetchPendingErpSyncOrders({
        limit: limit || 10,
        page: page || 1,
        search: searchTerm,
      })
      setOrdersData(data)
    } catch (error) {
      setOrdersData({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getOrders()
  }, [search])

  // Store the row params and open the confirmation modal
  const handleOpenResyncModal = (params: ICellRendererParams) => {
    setGridParams(params)
    openModal()
  }

  const columns = useMemo(
    () => getPendingErpSyncOrderColumns(handleOpenResyncModal, isEditor),
    [isEditor],
  )

  return (
    <>
      <DataTable
        columns={loading ? [] : columns}
        rows={loading ? null : ordersData?.docs}
        identifier="order_no"
      />

      {/* Confirm Resync Modal */}
      <ConfirmResyncOrderModal
        params={gridParams}
        closeModal={closeModal}
        isOpen={isOpen}
      />

      <DataTablePagination
        currentPage={ordersData?.page}
        totalPages={ordersData?.totalPages}
        hasNextPage={ordersData?.hasNextPage}
        hasPrevPage={ordersData?.hasPrevPage}
        limit={ordersData?.limit}
        nextPage={ordersData?.nextPage}
        prevPage={ordersData?.prevPage}
      />
    </>
  )
}

export default PendingErpSyncOrdersTable
